import { SubtextDisplay } from '../../../components/merch-card/subtext-display/SubtextDisplay';
import { useIsUngatedForInbound25 } from '../../../hooks/useIsUngated';
import { useProductDetails } from '../../../hooks/useProductDetails';
import { useIsSeatsUser } from '../../../hooks/useUserInfo';
import { isValidProductLevel, isValidSkuCategoryName } from '../../../utils/typeguards';
import { jsx as _jsx } from "react/jsx-runtime";
export const SubtextDisplayContainer = ({
  productApiName
}) => {
  const productResponse = useProductDetails({
    productApiName
  });

  // Base level product details
  const productDetails = productResponse.productDetails;
  const productLevel = productDetails === null || productDetails === void 0 ? void 0 : productDetails.productLevel;
  const isSeatsUser = useIsSeatsUser();
  const isUngatedForInbound25 = useIsUngatedForInbound25();
  const skuCategoryName = productDetails === null || productDetails === void 0 ? void 0 : productDetails.skuCategoryName;
  const quantityPacks = productDetails === null || productDetails === void 0 ? void 0 : productDetails.quantityPacks;

  // Matching quantity pack for the product
  const matchingQuantityPack = quantityPacks === null || quantityPacks === void 0 ? void 0 : quantityPacks.find(quantityPack => {
    return quantityPack.skuCategoryName === skuCategoryName;
  });
  const additionalUnitSkuId = matchingQuantityPack === null || matchingQuantityPack === void 0 ? void 0 : matchingQuantityPack.skuId;
  const quantityName = matchingQuantityPack === null || matchingQuantityPack === void 0 ? void 0 : matchingQuantityPack.quantityName;
  const includedWithParentProduct = matchingQuantityPack === null || matchingQuantityPack === void 0 ? void 0 : matchingQuantityPack.includedWithParentProduct;
  if (!isValidProductLevel(productLevel) || !isValidSkuCategoryName(skuCategoryName)) {
    return null;
  }
  return /*#__PURE__*/_jsx(SubtextDisplay, {
    quantityName: quantityName,
    productLevel: productLevel,
    isSeatsUser: isSeatsUser,
    skuCategoryName: skuCategoryName,
    isUngatedForInbound25: isUngatedForInbound25,
    additionalUnitSkuId: additionalUnitSkuId,
    includedWithParentProduct: includedWithParentProduct,
    queryParamTerm: 'annual'
  });
};